import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Badge } from '@shadcn/badge'
import { Button } from '@shadcn/button'
import { Skeleton } from '@shadcn/skeleton'

import { queryHello } from '@api/root/root.queries'

import SplitText from '@/components/react-bits/split-text'

export const Route = createFileRoute('/')({
  component: App,
})

function App() {
  const { t } = useTranslation()
  const { status } = useQuery(queryHello())

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="grid max-w-7xl grid-cols-4 gap-2 p-4">
        <SplitText
          text={t('testing-home-page.title')}
          className="col-span-4 text-center text-7xl font-semibold sm:whitespace-nowrap"
          delay={50}
          duration={1.25}
          ease="elastic.out(1, 0.3)"
          splitType="chars"
          from={{ opacity: 0, y: 40 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          rootMargin="-100px"
          textAlign="center"
          tag="h1"
        />
        <div className="bg-secondary col-span-4 row-span-2 flex items-center justify-between rounded-md p-4 sm:col-span-3">
          <h2 className="text-2xl font-semibold">
            {t('testing-home-page.backend.title')}
          </h2>
          <span>
            {status === 'pending' ? (
              <Skeleton className="bg-brand-100 h-6 w-24" />
            ) : (
              <Badge
                variant={status === 'success' ? 'default' : 'destructive'}
                className="text-md font-semibold"
              >
                {status === 'success'
                  ? t('testing-home-page.backend.status.success')
                  : t('testing-home-page.backend.status.error')}
              </Badge>
            )}
          </span>
        </div>
        <Route.Link
          to="/session/login"
          className="col-span-4 sm:col-span-1 sm:row-span-2"
        >
          <Button className="h-full w-full">
            {t('testing-home-page.links.login')}
          </Button>
        </Route.Link>
      </div>
    </div>
  )
}
